<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [modalHelpIndex]="modalHelpIndex" [verifyRequiredValidator]="verifyRequiredValidator"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="addSharedDataSet()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [modalDraggable]=false>

    <div class="modal-fill add-shared-data-set-grid">
        <res-generic-grid gridName="Data Sets" [automationId]="modalAutomationId" [updateStatusType]="updateStatusType"
            [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [pagerVisible]="false" [columnDefs]="columnDefs"
            [rowSelection]="rowSelection" [requestInfo]="requestInfo" [rowClassRules]="rowClassRules"
            [responseArrayCallback]="responseArrayCallback" [isRowSelectable]="isRowSelectable" [customGridClass]="'ag-row-click-selection' + (hasDisabledRow ? ' grid-with-disabled-rows' : '')">
        </res-generic-grid>
    </div>
    <div class="modal-row path-area" *ngIf="hasAddToProjectPermissions">
        <div class="modal-row-column-auto">
            <res-custom-checkbox [automationId]="automationId + '-add-to-project-data'" [(ngModel)]="addToProjectData"
                content="Add to Project Data"></res-custom-checkbox>
        </div>
    </div>
</res-base-modal>